<template>
  <div>
    <!-- 배너 -->
    <LinkookLiveBanner :class="$style.linkookLiveBanner" />
    <div :class="$style.container">
      <!-- 에러 상태 -->
      <div v-if="error" :class="$style.error">
        <p>{{ error }}</p>
        <button @click="fetchVenues" :class="$style.retryButton">다시 시도</button>
      </div>

      <!-- 공연장 데이터 -->
      <div v-else>
        <!-- 검색 및 필터 -->
        <div :class="$style.controls">
          <!-- 지역 필터 -->
          <div :class="$style.regionFilter">
            <!-- 지역 전체 보기 드롭다운 (햄버거) -->
            <div :class="$style.regionDropdown" ref="regionDropdownContainer">
              <button :class="$style.dropdownToggle" @click.stop="toggleRegionDropdown">
                <img src="@/assets/images/dehaze.png" alt="지역 필터 메뉴" :class="$style.dehazeIcon" />
              </button>
              <div v-if="showRegionDropdown" :class="$style.dropdownMenu">
                <button :class="[
                  $style.dropdownItem,
                  { [$style.activeDropdownItem]: selectedRegion === 'all' },
                ]" @click="selectRegionFromDropdown('all')">
                  전체
                </button>
                <button v-for="region in availableRegions" :key="region" :class="[
                  $style.dropdownItem,
                  { [$style.activeDropdownItem]: selectedRegion === region },
                ]" @click="selectRegionFromDropdown(region)">
                  {{ region }}
                </button>
              </div>
            </div>
            <div ref="regionFilterScroll" :class="$style.regionFilterScroll">
              <button data-region="all" :class="[
                $style.regionButton,
                { [$style.activeRegion]: selectedRegion === 'all' },
              ]" @click="selectRegion('all')">
                전체
              </button>
              <button v-for="region in availableRegions" :key="region" :data-region="region" :class="[
                $style.regionButton,
                { [$style.activeRegion]: selectedRegion === region },
              ]" @click="selectRegion(region)">
                {{ region }}
              </button>
            </div>
          </div>

          <!-- 검색 및 정렬 -->
          <div :class="$style.sortFilter">
            <div :class="$style.searchBox">
              <input v-model="searchQuery" type="text" placeholder="공연장명 검색" :class="$style.searchInput" />
            </div>

            <div :class="$style.filterBox">
              <button @click="toggleSort" :class="[$style.sortButton, $style.toggleSortButton]">
                {{ sortBy === "usage" ? "등록횟수" : "이름" }}
                <img :class="$style.sortIcon" src="@/assets/images/swap_vert.png" alt="정렬 변경" />
              </button>
            </div>
          </div>
        </div>

        <!-- 로딩 상태 -->
        <div v-if="loading" :class="$style.loading">
          <div :class="$style.spinner"></div>
          <p>공연장 정보를 불러오는 중...</p>
        </div>

        <!-- 공연장 목록 -->
        <div v-else :class="$style.venueList">
          <div v-for="venue in paginatedVenues" :key="venue.name" :class="$style.venueCard"
            @click="goToVenueDetail(venue.name)" style="cursor: pointer;">
            <!-- 공연장 이미지 -->
            <VenueImageUploader :venue-name="venue.name" :venue-image="venue.imageUrl" :show-controls="false"
              @image-updated="(url) => handleImageUpdated(venue, url)"
              @image-removed="() => handleImageRemoved(venue)" />

            <div :class="$style.venueInfo">
              <div :class="$style.venueHeader">
                <div :class="$style.venueTitleWrapper">
                  <h3 :class="$style.venueName">{{ venue.name }}
                  </h3>
                  <span v-if="venue.liveCount > 0" :class="$style.countBadge">{{ venue.liveCount }}</span>
                </div>
                <a v-if="venue.mapLink" :href="venue.mapLink" target="_blank" :class="$style.mapLink" @click.stop>
                  지도보기
                </a>
                <span v-else :class="$style.noMapLink">지도 미등록</span>
              </div>
              <div :class="$style.venueDetails">
                <div v-if="venue.address" :class="$style.detailItem">
                  <span :class="$style.detailLabel">주소:</span>
                  <span :class="$style.detailValue">{{ venue.address }}</span>
                </div>
                <div :class="$style.detailItem">
                  <span :class="$style.detailLabel">연락처:</span>
                  <span :class="$style.detailValue">{{ venue.contact || "미등록" }}</span>
                </div>

                <!-- 공연 리스트 -->
                <!-- <div v-if="venue.liveList && venue.liveList.length > 0" :class="$style.detailItem">
                  <div :class="$style.liveList">
                    <span v-for="(live, index) in getDisplayedLives(venue)" :key="index" :class="$style.liveItem"
                      @click.stop="goToLiveDetail(live.id)">
                      {{ live.title }}
                    </span>
                    <span v-if="venue.liveList.length > 5 && !venue.expanded" :class="$style.moreIndicator"
                      @click.stop="toggleVenueLives(venue)">
                      외 {{ venue.liveList.length - 5 }}개
                    </span>
                    <span v-if="venue.expanded && venue.liveList.length > 5" :class="$style.collapseIndicator"
                      @click.stop="toggleVenueLives(venue)">
                      접기
                    </span>
                  </div>
                </div> -->
                <!-- <div v-else :class="$style.detailItem">
                  <span :class="$style.detailLabel">진행된 공연:</span>
                  <span :class="$style.detailValue">공연 정보 없음</span>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- 페이지네이션 -->
        <div v-if="!loading && totalPages > 1" :class="$style.pagination">
          <button :class="$style.pageButton" @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
            ‹
          </button>
          <button v-for="page in pageRange" :key="page"
            :class="[$style.pageButton, { [$style.activePage]: page === currentPage }]" @click="goToPage(page)">
            {{ page }}
          </button>
          <button :class="$style.pageButton" @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages">
            ›
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { collection, getDocs } from "firebase/firestore";
import { ref as storageRef } from "firebase/storage";
import { getDownloadURL } from "@/utils/storageWithNavigation";
import { firestore, storage } from "/firebaseConfig";
import VenueImageUploader from "@/components/VenueImageUploader.vue";
import { useUserStore } from "@/store/user";
import LinkookLiveBanner from "@/components/layout/LinkookLiveBanner.vue";

export default {
  name: "VenueList",
  components: {
    VenueImageUploader,
    LinkookLiveBanner,
  },
  data() {
    return {
      venues: [],
      loading: true,
      error: null,
      searchQuery: "",
      sortBy: "usage",
      selectedRegion: "all",
      currentPage: 1,
      itemsPerPage: 10,
      userStore: useUserStore(),
      showRegionDropdown: false,
    };
  },
  computed: {
    // 지역 목록 추출 (공연장명 띄어쓰기 기준 첫 번째 단어)
    // 공연 횟수가 많은 지역 순으로 정렬
    availableRegions() {
      const regionCountMap = new Map();

      this.venues.forEach((venue) => {
        const region = this.extractRegion(venue.name);
        if (region) {
          // 해당 지역의 총 공연 횟수 누적
          const currentCount = regionCountMap.get(region) || 0;
          regionCountMap.set(region, currentCount + (venue.liveCount || 0));
        }
      });

      // 공연 횟수가 많은 순서로 정렬
      return Array.from(regionCountMap.keys()).sort((a, b) => {
        return regionCountMap.get(b) - regionCountMap.get(a);
      });
    },

    // 검색 및 정렬된 공연장 목록
    filteredVenues() {
      let filtered = [...this.venues];

      // 지역 필터
      if (this.selectedRegion !== "all") {
        filtered = filtered.filter((venue) => {
          const region = this.extractRegion(venue.name);
          return region === this.selectedRegion;
        });
      }

      // 검색 필터
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        filtered = filtered.filter((venue) => venue.name.toLowerCase().includes(query));
      }

      // 정렬
      switch (this.sortBy) {
        case "usage":
          filtered.sort((a, b) => (b.liveCount || 0) - (a.liveCount || 0));
          break;
        case "name":
          filtered.sort((a, b) => a.name.localeCompare(b.name));
          break;
      }

      return filtered;
    },

    // 페이지네이션된 공연장 목록
    paginatedVenues() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.filteredVenues.slice(startIndex, endIndex);
    },

    // 총 페이지 수
    totalPages() {
      return Math.ceil(this.filteredVenues.length / this.itemsPerPage);
    },

    // 페이지 범위
    pageRange() {
      const total = this.totalPages;
      const current = this.currentPage;

      if (total <= 5) {
        const pages = [];
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
        return pages;
      }

      let start, end;

      if (current <= 3) {
        start = 1;
        end = 5;
      } else if (current >= total - 2) {
        start = total - 4;
        end = total;
      } else {
        start = current - 2;
        end = current + 2;
      }

      const pages = [];
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },

    // 통계 데이터
    totalVenues() {
      return this.venues.length;
    },

    venuesWithMap() {
      return this.venues.filter((venue) => venue.mapLink).length;
    },

    recentVenues() {
      const oneWeekAgo = new Date();
      oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
      return this.venues.filter((venue) => {
        if (!venue.updatedAt) return false;
        return new Date(venue.updatedAt) > oneWeekAgo;
      }).length;
    },
  },
  watch: {
    searchQuery() {
      this.currentPage = 1;
      this.$nextTick(() => {
        this.loadVenueImagesForCurrentPage();
      });
    },
    sortBy() {
      this.currentPage = 1;
      this.$nextTick(() => {
        this.loadVenueImagesForCurrentPage();
      });
    },
    selectedRegion() {
      this.currentPage = 1;
      this.$nextTick(() => {
        this.loadVenueImagesForCurrentPage();
        this.scrollActiveRegionIntoView();
      });
    },
    currentPage() {
      this.loadVenueImagesForCurrentPage();
    },
  },
  async mounted() {
    await this.fetchVenues();
    document.addEventListener("click", this.handleRegionDropdownClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleRegionDropdownClickOutside);
  },
  methods: {
    // 공연장명에서 지역 추출 (띄어쓰기 기준 첫 번째 단어)
    extractRegion(venueName) {
      if (!venueName) return null;
      const parts = venueName.trim().split(" ");
      return parts.length > 0 ? parts[0] : null;
    },

    // 지역 선택
    selectRegion(region) {
      this.selectedRegion = region;
    },

    toggleRegionDropdown() {
      this.showRegionDropdown = !this.showRegionDropdown;
    },

    selectRegionFromDropdown(region) {
      this.selectedRegion = region;
      this.showRegionDropdown = false;
    },

    handleRegionDropdownClickOutside(event) {
      const el = this.$refs.regionDropdownContainer;
      if (el && !el.contains(event.target)) {
        this.showRegionDropdown = false;
      }
    },

    scrollActiveRegionIntoView() {
      const scrollEl = this.$refs.regionFilterScroll;
      if (!scrollEl) return;
      const target = scrollEl.querySelector(`[data-region="${this.selectedRegion}"]`);
      if (target) {
        target.scrollIntoView({ inline: "center", block: "nearest", behavior: "smooth" });
      }
    },

    async fetchVenues() {
      try {
        this.loading = true;
        this.error = null;

        // places와 lives 데이터를 병렬로 가져오기
        const [venuesSnapshot, livesSnapshot] = await Promise.all([
          getDocs(collection(firestore, "places")),
          getDocs(collection(firestore, "lives")),
        ]);

        // 각 공연장별 공연 횟수 및 공연 리스트 계산
        const venueUsageMap = new Map();
        const venueLivesMap = new Map();

        livesSnapshot.docs.forEach((doc) => {
          const liveData = doc.data();

          // 승인된 공연만 포함
          if (!liveData.approved) {
            return;
          }

          const venueName = liveData.place || "미지정";

          // 공연 횟수 계산
          venueUsageMap.set(venueName, (venueUsageMap.get(venueName) || 0) + 1);

          // 공연 리스트 수집
          if (!venueLivesMap.has(venueName)) {
            venueLivesMap.set(venueName, []);
          }
          venueLivesMap.get(venueName).push({
            id: doc.id, // 공연 ID 추가
            title: liveData.title || "제목 없음",
            date: liveData.date || null,
            artist: liveData.artist || "아티스트 미지정",
          });
        });

        // 각 공연장의 공연 리스트를 날짜순으로 정렬 (최신순)
        venueLivesMap.forEach((lives) => {
          lives.sort((a, b) => {
            if (!a.date) return 1;
            if (!b.date) return -1;
            return new Date(b.date) - new Date(a.date);
          });
        });

        // 모든 공연장 정보 수집 (places 컬렉션 + lives에서 나온 공연장)
        const allVenues = new Map();

        // places 컬렉션에서 등록된 공연장들
        venuesSnapshot.docs.forEach((doc) => {
          const data = doc.data();
          const venueName = data.name || doc.id;
          allVenues.set(venueName, {
            name: venueName,
            mapLink: data.mapLink || null,
            updatedAt: data.updatedAt || null,
            liveCount: venueUsageMap.get(venueName) || 0,
            liveList: venueLivesMap.get(venueName) || [], // 공연 리스트
            img: data.img || null, // 공연장 이미지 파일명
            imageUrl: null, // 실제 이미지 URL (나중에 로드)
            contact: data.contact || null, // 연락처 정보
            address: data.address || null, // 주소 정보
          });
        });

        // lives에는 있지만 places에 없는 공연장들도 추가
        venueUsageMap.forEach((count, venueName) => {
          if (!allVenues.has(venueName)) {
            allVenues.set(venueName, {
              name: venueName,
              mapLink: null,
              updatedAt: null,
              liveCount: count,
              liveList: venueLivesMap.get(venueName) || [], // 공연 리스트
              img: null,
              imageUrl: null,
              contact: null,
              address: null,
            });
          }
        });

        // '링꾹라이브'는 목록에서 제외
        this.venues = Array.from(allVenues.values()).filter(
          (v) => v.name !== "링꾹라이브"
        );

        // 이미지 로드는 백그라운드로 (카드 표시는 즉시, 이미지는 개별 카드 단위로 차차 채워짐)
        this.loadVenueImagesForCurrentPage();

        this.loading = false;
      } catch (error) {
        console.error("Error fetching venues:", error);
        this.error = "데이터를 불러오는 중 오류가 발생했습니다.";
        this.loading = false;
      }
    },

    formatDate(date) {
      if (!date) return "-";
      try {
        if (typeof date === "string") {
          return date;
        }
        if (date instanceof Date) {
          return date.toLocaleDateString("ko-KR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          });
        }
        return "-";
      } catch (e) {
        console.error("날짜 포맷 오류:", e);
        return "-";
      }
    },

    goToPage(page) {
      this.currentPage = page;
    },

    // 현재 페이지의 공연장들만 이미지 로드
    async loadVenueImagesForCurrentPage() {
      const currentPageVenues = this.paginatedVenues;

      const imageLoadPromises = currentPageVenues
        .filter((venue) => venue.img && !venue.imageUrl)
        .map(async (venue) => {
          try {
            const imageRef = storageRef(storage, `venue/${venue.img}`);
            const imageUrl = await getDownloadURL(imageRef);
            venue.imageUrl = imageUrl;
          } catch (error) {
            console.warn(`공연장 이미지 URL 생성 실패 (${venue.name}):`, error);
            venue.imageUrl = null;
          }
        });

      await Promise.all(imageLoadPromises);
    },

    // 공연장 이미지 업데이트 핸들러
    handleImageUpdated(venue, url) {
      // venues 배열에서 해당 공연장 찾아서 imageUrl 업데이트
      const venueIndex = this.venues.findIndex((v) => v.name === venue.name);
      if (venueIndex !== -1) {
        this.venues[venueIndex].imageUrl = url;
        // console.log(`공연장 이미지 업데이트: ${venue.name}`);
      }
    },

    // 공연장 이미지 삭제 핸들러
    handleImageRemoved(venue) {
      // venues 배열에서 해당 공연장 찾아서 imageUrl을 null로 설정
      const venueIndex = this.venues.findIndex((v) => v.name === venue.name);
      if (venueIndex !== -1) {
        this.venues[venueIndex].imageUrl = null;
        // console.log(`공연장 이미지 삭제: ${venue.name}`);
      }
    },

    // 공연장별 공연 리스트 확장/축소 토글
    toggleVenueLives(venue) {
      const venueIndex = this.venues.findIndex((v) => v.name === venue.name);
      if (venueIndex !== -1) {
        // Vue 3에서는 직접 할당으로 반응성 유지
        this.venues[venueIndex].expanded = !venue.expanded;
      }
    },

    // 표시할 공연 리스트 가져오기
    getDisplayedLives(venue) {
      if (!venue.liveList || venue.liveList.length === 0) {
        return [];
      }

      if (venue.expanded || venue.liveList.length <= 5) {
        return venue.liveList;
      }

      return venue.liveList.slice(0, 5);
    },

    // 라이브 상세 페이지로 이동
    goToLiveDetail(liveId) {
      if (liveId) {
        this.$router.push(`/live/${liveId}`);
      }
    },

    // 정렬 방식 토글
    toggleSort() {
      this.sortBy = this.sortBy === "usage" ? "name" : "usage";
    },

    // 공연장 상세 페이지로 이동
    goToVenueDetail(venueName) {
      if (venueName) {
        this.$router.push(`/venue/${encodeURIComponent(venueName)}`);
      }
    },
  },
};
</script>

<style module>
/* 배너 최소 높이 설정 */
.linkookLiveBanner {
  min-height: 150px;
}

.container {
  width: 90%;
  margin: 0 auto;
  min-height: 100vh;
  font-family: "NanumSquareRoundR", sans-serif;
  padding: 15px 10px;
}

.header {
  text-align: center;
  padding: 20px;
  border-radius: 15px;
  margin-bottom: 20px;
}

.title {
  font-size: 2rem;
  color: #333;
  margin: 0 0 10px 0;
  font-weight: bold;
}

.subtitle {
  font-size: 1.1rem;
  color: #666;
  margin: 0;
}

/* 로딩 상태 */
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #66bdff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.error {
  text-align: center;
  padding: 60px 20px;
  border-radius: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.retryButton {
  background: #3498db;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  margin-top: 15px;
}

.retryButton:hover {
  background: #2980b9;
}

.summary {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 30px;
}

.summaryCard {
  text-align: center;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background: white;
}

.summaryCard h3 {
  margin: 0 0 10px 0;
  font-size: 1rem;
  color: #666;
}

.summaryNumber {
  margin: 0;
  font-size: 2rem;
  font-weight: bold;
  color: #333;
}

/* 필터 및 검색 컨트롤 */
.controls {
  display: flex;
  margin-top: 0px;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  margin-bottom: 20px;
}

/* 지역 필터 */
.regionFilter {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
  min-width: 0;
}

.regionDropdown {
  position: relative;
  flex-shrink: 0;
}

.dropdownToggle {
  height: 34px;
  width: 34px;
  border-radius: 8px;
  background: white;
  border: 1px solid #ddd;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-family: "NanumSquareRoundR", sans-serif;
}

.dropdownToggle:hover {
  background: #f8f9fa;
  border-color: #cbd5e1;
}

.dehazeIcon {
  width: 22px;
  height: 22px;
  object-fit: contain;
  filter: brightness(0) invert(0.4);
  /* #666 */
}

.dropdownMenu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  min-width: 160px;
  max-height: min(320px, 50vh);
  overflow-y: auto;
  animation: regionDropdownSlide 0.2s ease;
}

@keyframes regionDropdownSlide {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dropdownItem {
  width: 100%;
  padding: 10px 14px;
  background: white;
  border: none;
  text-align: left;
  font-size: 0.875rem;
  color: #64748b;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: "NanumSquareRoundR", sans-serif;
  border-bottom: 1px solid #f1f5f9;
}

.dropdownItem:last-child {
  border-bottom: none;
}

.dropdownItem:hover {
  background: #f8fafc;
  color: #334155;
}

.dropdownItem.activeDropdownItem {
  background: #1e293b;
  color: white;
  font-weight: bold;
}

.regionFilterScroll {
  display: flex;
  gap: 8px;
  align-items: center;
  overflow-x: auto;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.regionFilterScroll::-webkit-scrollbar {
  display: none;
}

.regionButton {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.875rem;
  font-family: "NanumSquareRoundB", sans-serif;
  transition: all 0.2s ease;
  white-space: nowrap;
}


.activeRegion {
  background: #66bdff;
  color: white;
  border-color: #66bdff;
}

.sortFilter {
  flex: 1;
  display: flex;
  gap: 8px;
  min-width: 200px;
  width: 100%;
}

.searchBox {
  flex: 1;
  min-width: 100px;
  max-width: none;
}

.searchInput {
  width: 100%;
  height: 34px !important;
  padding: 0 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 0.875rem;
  font-family: "NanumSquareRoundR", sans-serif;
  transition: border-color 0.2s ease;
}

.searchInput:focus {
  outline: none;
  border-color: #66bdff;
}

.filterBox {
  flex-shrink: 0;
}

.sortButton {
  padding: 8px 12px;
  background: #66bdff;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.8125rem;
  font-family: "NanumSquareRoundB", sans-serif;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.sortButton:hover {
  background: #4a9eff;
}

.sortIcon {
  width: 14px;
  height: 14px;
  filter: brightness(0) invert(1);
}

.toggleSortButton {
  padding: 8px 12px;
  background: #66bdff;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.8125rem;
}

.venueList {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.venueHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.venueTitleWrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.venueCard {
  display: flex;
  flex-direction: column;
  padding: 15px;
  margin-bottom: 0;
  border-radius: 12px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background: white;
  overflow: scroll;
}

.venueCard:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.venueInfo {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 0px;
  margin-top: 10px;
  padding: 10px;
  gap: 10px;
  justify-content: flex-start;
}

.venueName {
  margin: 0px;
  font-size: 1.1rem;
  color: #333;
  font-weight: bold;
  flex: 1;
  min-width: 0;
  font-family: "NanumSquareRoundEB", sans-serif;
}

.countBadge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  background: linear-gradient(135deg, #a0b1f9 0%, #5daafc 100%);
  color: white;
  border-radius: 12px;
  font-size: 0.6875rem;
  font-weight: bold;
  font-family: "NanumSquareRoundB", sans-serif;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
  flex-shrink: 0;
}

.venueDetails {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detailItem {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 4px;
}

.detailLabel {
  font-weight: 600;
  color: #666;
  min-width: auto;
  font-size: 14px;
}

.detailValue {
  color: #333;
  font-size: 14px;
}

.liveCountBadge {
  background: linear-gradient(135deg, #a0b1f9 0%, #5daafc 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: bold;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
  display: inline-block;
  transform: scale(1);
  transition: all 0.2s ease;
  margin-top: 10px;
}

.liveCountBadge:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.mapLink {
  color: #007bff;
  font-size: 14px;
  text-decoration: none;
  font-weight: 500;
  margin-left: 10px;
}

.mapLink:hover {
  text-decoration: underline;
}

.noMapLink {
  color: #999;
  font-style: italic;
}

/* 공연 리스트 스타일 */
.liveList {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
}

.liveItem {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #f1f3f4;
  color: #333;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.85rem;
  transition: all 0.2s ease;
  cursor: pointer;
  user-select: none;
}

.liveItem:hover {
  background: #007bff;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.2);
}

.moreIndicator {
  background: #ddd;
  color: #666;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.85rem;
  font-style: italic;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.moreIndicator:hover {
  background: #c0c0c0;
}

.collapseIndicator {
  background: #007bff;
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.collapseIndicator:hover {
  background: #0056b3;
}

/* 페이지네이션 스타일 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 25px;
  gap: 6px;
  flex-wrap: wrap;
}

.pageButton {
  padding: 6px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #ffffff;
  color: #666;
  font-size: 0.8125rem;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 32px;
  text-align: center;
}

.pageButton:hover:not(.activePage):not(:disabled) {
  background: #f8f9fa;
  border-color: #ccc;
  color: #333;
}

.pageButton:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  color: #ccc;
  background: #f8f9fa;
}

.activePage {
  background: #222;
  color: #ffffff;
  border-color: #222;
}

/* ==============================================
   반응형 디자인
   - Medium: 481px ~ (기본 스타일, 최대 1024px)
   - Small: ~480px
   ============================================== */

/* Small (~480px) - 모바일 */
@media screen and (max-width: 480px) {
  .linkookLiveBanner {
    min-height: 80px;
  }

  .container {
    padding: 10px 0px;
  }

  .header {
    padding: 15px;
    margin-bottom: 15px;
  }

  .title {
    font-size: 1.8rem;
  }

  .summary {
    grid-template-columns: 1fr;
  }

  .controls {
    gap: 8px;
  }

  .regionFilter {
    gap: 6px;
  }

  .regionFilterScroll {
    gap: 6px;
  }

  .dropdownToggle {
    height: 28px;
    width: 28px;
    border-radius: 6px;
  }

  .dehazeIcon {
    width: 18px;
    height: 18px;
  }

  .dropdownItem {
    padding: 10px 12px;
    font-size: 0.8125rem;
  }

  .regionButton {
    padding: 6px 12px;
    font-size: 0.75rem;
  }

  .activeRegion:hover {
    background: #66bdff;
    color: white;
    border-color: #66bdff;
  }

  .searchInput {
    height: 31px !important;
    font-size: 0.75rem;
  }

  .sortButton {
    padding: 8px 10px;
    font-size: 0.75rem;
  }

  .sortButton:hover {
    background: #4a9eff;
  }

  .toggleSortButton {
    padding: 8px 10px;
    font-size: 0.75rem;
  }

  .sortIcon {
    width: 14px;
    height: 14px;
  }

  .venueList {
    grid-template-columns: repeat(1, 1fr);
    gap: 20px;
  }


  .venueCard {
    padding: 12px;
  }

  .venueInfo {
    gap: 8px;
  }

  .venueName {
    font-size: 1rem;
  }

  .countBadge {
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    font-size: 0.625rem;
  }

  .detailLabel,
  .detailValue {
    font-size: 13px;
  }

  .liveItem {
    max-width: calc(100vw - 80px);
    min-width: 0;
    flex: 1 1 auto;
  }

  .liveList {
    max-width: 100%;
    overflow: hidden;
  }

  .liveCountBadge {
    font-size: 12px;
    padding: 4px 8px;
  }

  .pagination {
    gap: 4px;
    margin-top: 18px;
  }

  .pageButton {
    padding: 5px 8px;
    font-size: 0.6875rem;
    min-width: 26px;
    border-radius: 5px;
  }
}
</style>
